import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-546" data-mp="qbcxkdc16hs1">
      <SEO title="Privacy Policy | KittyPot" description="How KittyPot, a shared expense and settlement tracker, collects and protects your data. The current MVP covers expense tracking and manual settlement only; KittyPot does not hold or move money." ogTitle="KittyPot Privacy Policy" ogDescription="How KittyPot handles your data as a shared expense and settlement tracker." path="/privacy-policy" data-id="element-547" data-mp="mbuc9ggas4oo" />
      <Navbar data-id="element-548" data-mp="156j2ewze4ajs" />
      <main className="pt-32 pb-24" data-id="element-549" data-mp="21pzyk56qd9wc">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-550" data-mp="21r1mha8uhqvh">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-551" data-mp="1wz00uxpsenss">
            Privacy Policy
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-552" data-mp="50rbr86xfcra">
            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-553" data-mp="9zujx1i7dz3h">
              General
            </h2>
            <p data-id="element-554" data-mp="3rh59ieriybzq">
              KittyPot is a shared expense and settlement tracking app. Your
              privacy is important to us. It is KittyPot Ltd.'s policy to
              respect your privacy regarding any information we may collect from
              you across our website, https://www.kittypot.com, and any other
              sites or services we own and operate.
            </p>
            <p data-id="element-555" data-mp="38i9itdevkfqn">
              <strong data-id="element-556" data-mp="38it2ozo35e7b">Data we may collect:</strong> We may collect account
              information, waitlist/contact form data, expense entries,
              kitty/member information, manual settlement statuses, guest/local
              data (where applicable), and device/local storage data. We only
              access your contacts if the app uses on-device contact matching
              (which is processed locally on your device). We also use analytics
              and cookies on our website.
            </p>

            <p data-id="element-557" data-mp="157mpibwhik49">
              We only collect personal information where it is genuinely
              necessary to provide our services. We collect information by fair
              and lawful means, with your knowledge and consent, and we clearly
              explain why it is being collected and how it will be used.
            </p>

            <p data-id="element-558" data-mp="1nzp8vv0igei7">
              We retain personal information only for as long as necessary to
              deliver the service you have requested. Any data we store is
              protected using commercially reasonable measures to prevent loss,
              theft, unauthorised access, disclosure, copying, use, or
              modification.
            </p>

            <p data-id="element-559" data-mp="2bqur2gtxbivo">
              We do not share personally identifiable information publicly or
              with third parties, except where required to do so by law or where
              necessary to provide our services.
            </p>

            <p data-id="element-560" data-mp="3uk4kqni498f9">
              You may request the deletion of your personal data at any time,
              and we will securely erase it in accordance with applicable data
              protection laws.
            </p>

            <p data-id="element-561" data-mp="7fygu02rjmfb">
              Our website may contain links to external websites that are not
              operated by us. Please note that we have no control over the
              content or practices of these sites and cannot accept
              responsibility or liability for their respective privacy policies.
            </p>

            <p data-id="element-562" data-mp="m54bdaqnoogv">
              You are free to decline our request for personal information,
              however this may mean we are unable to provide certain services.
            </p>

            <p data-id="element-563" data-mp="v6lu70vg7499">
              Your continued use of our website will be regarded as acceptance
              of our privacy practices. If you have any questions about how we
              handle user data and personal information, please contact us at
              support@kittypot.com.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-564" data-mp="hi0rkjv4wuri">
              Sign-Up & Contact
            </h2>
            <p data-id="element-565" data-mp="w9j7yirworbe">
              You can join our waitlist or contact us via the contact form on
              our website. If you have any questions or require assistance,
              we're always happy to help.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-566" data-mp="3upc1n1p5t4ji">
              Cookie Policy
            </h2>
            <p data-id="element-567" data-mp="di03e7i8h579">
              Cookies are small text files placed on your device by a website's
              server. They help websites function properly, remember user
              preferences, and improve the overall user experience.
            </p>

            <p data-id="element-568" data-mp="1oxyj2u7x2phg">We use cookies for the following purposes:</p>
            <ul className="list-none space-y-4" data-id="element-569" data-mp="1jw981ekp2btd">
              <li data-id="element-570" data-mp="1rgju1gpv7529">
                <strong data-id="element-571" data-mp="1rgabge75g06l">a) Identification</strong> — Cookies help us recognise
                your device so you don't need to re-enter information repeatedly
                when navigating between pages.
              </li>
              <li data-id="element-572" data-mp="1ih6pn2gll6oe">
                <strong data-id="element-573" data-mp="1ihojjsfsf8t5">b) Analytics</strong> — Cookies help us understand how
                visitors use our website, such as which pages are viewed and how
                often, so we can improve performance and usability.
              </li>
            </ul>

            <p data-id="element-574" data-mp="2f6e5puyg6nkx">
              You can choose to disable cookies through your browser settings.
              Please note that disabling cookies may limit certain functionality
              of the website.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-575" data-mp="2t5x96agbdaqw" />
    </div>;
}